import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { TextRepeatTool } from "../components/TextRepeatTool";
import { TrBreadcrumb } from "../components/TrBreadcrumb";
import { TrExplainer } from "../components/TrExplainer";

export function TextRepeatPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <TrBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.tr_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.tr_intro()}
          </p>
        </header>

        <TextRepeatTool />

        <TrExplainer
          howTo={m.tr_howto()}
          faqs={[
            { q: m.tr_faq1_q(), a: m.tr_faq1_a() },
            { q: m.tr_faq2_q(), a: m.tr_faq2_a() },
            { q: m.tr_faq3_q(), a: m.tr_faq3_a() },
            { q: m.tr_faq4_q(), a: m.tr_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
